export const NON_PROFIT_PAYMENT_PLAN_ID = 3;

export const USE_BALANCE_PAYMENT_PERIOD = 0;

export const CANCELED_PAYMENT_PERIOD = 0;

export const ONE_MONTH_PAYMENT_PERIOD = 1;

export const SIX_MONTHS_PAYMENT_PERIOD = 6;

export const TWELVE_MONTHS_PAYMENT_PERIOD = 12;
